export default "__VITE_ASSET__C5VXwEmY__"